import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import translations from "./translations";

const initializeI18n = () => {
  const language = localStorage.getItem("language");

  return i18n.use(initReactI18next).init({
    resources: translations,
    lng: language ?? "en",
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });
};

export default initializeI18n;
